import React, {PropTypes} from 'react';
import Checkbox from 'material-ui/Checkbox';
import SelectEmployee from '../../../components/common/forms/SelectEmployee';

class LeaveSearchFilter extends React.Component {

    constructor() {
      super();
      this.state={exit: false,all: false,selected: null};
      this.select= this.select.bind(this);
      this.unSelect = this.unSelect.bind(this);

    }
  select(empId)
  {
    this.setState({selected: empId});
  }
  unSelect()
  {
    this.setState({selected: null})
  }

    render() {
        return (
          <div className="col-md-12" style={{borderBottomStyle: 'green'}}>
            <div className="col-md-3">
            <SelectEmployee activeEmployees={this.props.activeEmployees} select={this.select} unSelect = {this.unSelect}/>
          </div>
          <div style={{marginTop: "3%"}} className="col-md-2">
        <Checkbox
          label={this.props.option1}
          checked={this.state.all} onCheck={()=>{

        if(this.state.exit)
        this.setState({all: !this.state.all,exit: false});
        this.setState({all: !this.state.all})
      }} /></div>

            <div style={{marginTop: "3%"}} className="col-md-2">
      <Checkbox
        label={this.props.option2}

        checked={this.state.exit} onCheck={()=>{
          if(this.state.all)
          this.setState({exit: !this.state.exit,all: false})
          else
            this.setState({exit: !this.state.exit})

    }}/>
            </div>
            <div style={{marginTop: '3%'}} className="col-md-2">
              <button className="btn btn-default btn-block" onClick={()=>{
              this.props.onSubmit({
                  selected: this.state.selected,
                  option1: this.state.all,
                  option2: this.state.exit

              });

              }}>Search</button>
              </div>

    </div>

        );
    }
}

LeaveSearchFilter.propTypes = {};

export default LeaveSearchFilter;





/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveBalance/LeaveSearchFilter.js
 **/